import { render, staticRenderFns } from "./AddressSelect.vue?vue&type=template&id=e963fda8"
import script from "./AddressSelect.vue?vue&type=script&lang=js"
export * from "./AddressSelect.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports